interface ICalculadoraDeComissao {
  calcularComissaoVendedor: (valorTotalPresente: number) => number
}

export class CalculadoraDeComissao implements ICalculadoraDeComissao {
  constructor(readonly percentualComissaoVendedor: number) {}
  calcularComissaoVendedor(valorTotalPresente: number) {
    const taxaComissaoVendedor = this.percentualComissaoVendedor / 100
    return valorTotalPresente * taxaComissaoVendedor
  }
}
